<template lang="pug">
#heatmap_iframe
  iframe#iframe_scroll_heatmap(:src="this.display_iframe_url", :width="iframe_width", :height="iframe_height", frameborder="0", scrolling="no", style="overflow: visible;", v-if="show_iframe")
  #canvas_res
</template>


<!-- <style scoped>
#iframe_scroll_heatmap {
  background-color: #ff0011
}
</style> -->

<script>
import Vue from 'vue';

export default {
  props: {
    new_ui: Boolean,
    pc_page_height_changed: Boolean,
    sp_page_height_changed: Boolean,
    iframe_url: String,
    source_url: String,
    pc_height: String,
    sp_height: String,
    design_id: {
      type: String,
      default: "0"
    },
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data() {
    return {
      show_iframe: true,
      pc_width: 700,
      sp_width: 375,
      designId: String,
    }
  },
  methods:{
    handleIframeMessage(event) {
      // Adjust the height of the iframe based on the message data
      var iframe_scroll_heatmap = document.getElementById('iframe_scroll_heatmap')
      if (iframe_scroll_heatmap && event.data.iframeHeight) {
        if(this.$store.state[this.state_name].device == "pc"){
          const new_height = event.data.iframeHeight
          const old_height = this.$store.state[this.state_name].page_height
          if (!this.pc_page_height_changed){
            this.$store.commit( `${this.state_name}/setPageHeight`, new_height)
          }  
        } else{
          if (!this.sp_page_height_changed){
            this.$store.commit( `${this.state_name}/setPageHeight`, event.data.iframeHeight)
          }
        }
      }
    },

    async initIframe(){
      if (this.new_ui) {
        this.pc_width = 1200
      }
      var iframe_scroll_heatmap = document.getElementById('iframe_scroll_heatmap')
      iframe_scroll_heatmap.style.height = null;
      if(this.hasDimentions()){
        await this.setIframeDimention()
        this.$store.commit( `${this.state_name}/setShowScrollHeatmap`, true )
      } else {
        iframe_scroll_heatmap.addEventListener('load', async function(){
          this.$store.commit( `${this.state_name}/setShowScrollHeatmap`, false )
          this.$store.commit( `${this.state_name}/setShowClickHeatmap`, false )

          await this.setIframeDimention()
          this.$store.commit( `${this.state_name}/setShowScrollHeatmap`, true )

        }.bind(this), true);
      }
      window.addEventListener('message', this.handleIframeMessage);
    },

    async setIframeDimention(){
      var iframe_scroll_heatmap = document.getElementById('iframe_scroll_heatmap')
      if(this.hasDimentions()){
        if(this.$store.state[this.state_name].device == "pc"){
          this.$store.commit( `${this.state_name}/setPageHeight`, this.pc_height )
          this.$store.commit( `${this.state_name}/setPageWidth`, this.pc_width )
        } else {
          this.$store.commit( `${this.state_name}/setPageHeight`, this.sp_height )
          this.$store.commit( `${this.state_name}/setPageWidth`, this.sp_width )
        }
      } else {
        await sleep(1000)
        var height = iframe_scroll_heatmap.contentWindow.document.getElementsByTagName('body')[0].scrollHeight
        var width = iframe_scroll_heatmap.contentWindow.document.getElementsByTagName('body')[0].scrollWidth;
        this.$store.commit( `${this.state_name}/setPageHeight`, height )
        this.$store.commit( `${this.state_name}/setPageWidth`, parseInt(width) )
      }
    },
    hasDimentions(){
      if(this.pc_height != "" && this.sp_height != ""){
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    device: async function (val) {
      await this.initIframe()
      // window.addEventListener('message', this.handleIframeMessage);
    },
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessage);
  },
  async mounted(){
    await Vue.nextTick()
    this.designId = this.design_id
    this.initIframe()
    // window.addEventListener('message', this.handleIframeMessage);
  },
  computed: {
    device() {
      return this.$store.state[this.state_name].device;
    },
    display_iframe_url(){
      this.designId = this.$store.state[this.state_name].heatmap_design_id;
      if(this.designId){
        return this.iframe_url + "?device=" + this.$store.state[this.state_name].device + "&design_id=" + this.designId;
      }
      else{
        return this.iframe_url + "?device=" + this.$store.state[this.state_name].device;
      }
    },
    iframe_width(){
      if(this.$store.state[this.state_name].device == "pc"){
        if(!this.$store.state[this.state_name].page_width){
          return "1400px";
        } else {
          return this.$store.state[this.state_name].page_width + "px";
        }
      } else {
        if(!this.$store.state[this.state_name].page_width){
          return "375px";
        } else {
          return this.$store.state[this.state_name].page_width + "px";
        }
      }
    },
    iframe_height(){
      if(!this.$store.state[this.state_name].page_height){
        return "5000px";
      } else {
        return this.$store.state[this.state_name].page_height + "px"
      }
    }
  }
}
</script>
